<div class="modal-header">
  @if (isNewMachine) {
    <h4 class="modal-title h5" translate>New machine</h4>
  }
  @if (!isNewMachine) {
    <h4 class="modal-title h5" translate>Edit machine</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="onSave()" [formGroup]="machineForm">
  <div class="modal-body">

    @if (isNewMachine) {
      <div class="alert alert-secondary">
        <span class="mr-2" translate>Import settings from another machine</span>
        <button (click)="importSettings()" class="btn btn-outline-primary mr-2" type="button">
          <span translate>Select Machine</span>
        </button>
      </div>
    }

    <div class="form-row">
      <!-- DISPLAY NAME -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="type" translate>Display name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input [ngClass]="{ 'is-invalid': submitted && f.type.errors }" class="form-control" formControlName="type"
            id="type" name="type"
            type="text">
            @if (submitted && f.type.errors) {
              <div class="invalid-feedback">
                @if (f.type.errors.required) {
                  <span translate>Display name required</span>
                }
              </div>
            }
          </div>
        </div>

        <!--ORGANIZATION-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="parentId" translate>Organization</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            @if (isLoadingOrganizations) {
              <span class="fa-solid fa-gear fa-spin"></span>
            }
            <ng-select (change)="onOrganizationChange($event)" [items]="possibleOrganizations"
              [loading]="isLoadingOrganizations"
              [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }"
              bindLabel="name"
              bindValue="id" formControlName="parentId"
              id="parentId">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }" class="form-control"
              id="selectedParentId"
              name="parentId" type="text">

              @if (submitted && f.parentId.errors) {
                <div class="invalid-feedback">
                  @if (f.parentId.errors.required) {
                    <span translate>Organization
                    required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="form-row">
          <!-- NAME -->
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="name" translate>Name</label>
              <scitis-required-field-indicator></scitis-required-field-indicator>
              <input (input)="onNameChanged()" [ngClass]="{ 'is-invalid': f.name.errors }" class="form-control"
                formControlName="name" id="name"
                name="name" type="text">
                @if (f.name.errors) {
                  <div class="invalid-feedback">
                    @if (f.name.errors.required) {
                      <span translate>Machine name required</span>
                    }
                    @if (f.name.errors.used) {
                      <span translate>The machine name is already used!</span>
                    }
                    @if (f.name.errors.pattern) {
                      <span
                      translate>The name can only consist of latin letters, numbers, underscores.</span>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- MACHINERY GROUP-->
            @if (displayGroup) {
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label for="group" translate>Machinery group</label>
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                  @if (isLoadingMachineGroups) {
                    <span class="fa-solid fa-gear fa-spin"></span>
                  }
                  <ng-select [items]="possibleMachineGroups" [loading]="isLoadingMachineGroups"
                    [ngClass]="{ 'is-invalid': submitted && f.group.errors }"
                    bindLabel="name"
                    bindValue="id" formControlName="group"
                    id="group">
                  </ng-select>
                  <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.group.errors }" class="form-control"
                    id="selectedMachineGroup"
                    name="group" type="text">
                    @if (submitted && f.group.errors) {
                      <div class="invalid-feedback">
                        @if (f.group.errors.required) {
                          <span translate>Machinery group
                          required</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              @if (!displayGroup) {
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label for="externalId" translate>External id</label>
                    <input class="form-control" [readonly]="true" [disabled]="true"
                      formControlName="externalId" id="externalId"
                      name="externalId" type="text">
                    </div>
                  </div>
                }
              </div>

              <div class="form-row">
                <!-- CATEGORY -->
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label for="category" translate>Category</label>
                    <scitis-required-field-indicator></scitis-required-field-indicator>
                    @if (isLoadingCategories) {
                      <span class="fa-solid fa-gear fa-spin"></span>
                    }
                    <ng-select (change)="onMachineCategoryChange($event)"
                      [loading]="isLoadingCategories"
                      [ngClass]="{ 'is-invalid': submitted && f.category.errors }"
                      formControlName="category"
                      [items]="possibleCategories"
                      bindLabel="displayName"
                      id="category">
                    </ng-select>
                    <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.category.errors }" class="form-control"
                      id="selectedCategory"
                      name="category" type="text">
                      @if (submitted && f.category.errors) {
                        <div class="invalid-feedback">
                          @if (f.category.errors.required) {
                            <span translate>Category required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <!-- TABLEAU PROJECT -->
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label for="tableauProjectId" translate>Tableau project</label>
                      @if (isLoadingTableauProjects) {
                        <span class="fa-solid fa-gear fa-spin"></span>
                      }
                      <ng-select [items]="possibleTableauProjects"
                        [loading]="isLoadingTableauProjects"
                        [ngClass]="{'is-invalid': submitted && f.tableauProjectId.errors}" bindLabel="name"
                        bindValue="id"
                        formControlName="tableauProjectId" id="tableauProjectId">
                      </ng-select>
                    </div>
                  </div>

                </div>

                <div class="form-row">
                  <!-- GOOGLE PROJECT ID -->
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label for="projectId" translate>Google project id</label>
                      <scitis-required-field-indicator></scitis-required-field-indicator>
                      <input [ngClass]="{ 'is-invalid': submitted && f.projectId.errors }" class="form-control"
                        formControlName="projectId" id="projectId" name="projectId"
                        type="text">
                        @if (submitted && f.projectId.errors) {
                          <div class="invalid-feedback">
                            @if (f.projectId.errors.required) {
                              <span translate>Google project name required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <!--GOOGLE DATASET LOCATION-->
                    <div class=" col-12 col-lg-6">
                      <div class="form-group">
                        <label for="datasetLocation" translate>Google dataset location</label>
                        <scitis-required-field-indicator></scitis-required-field-indicator>
                        <ng-select [items]="GOOGLE_DATASET_LOCATIONS"
                          [ngClass]="{ 'is-invalid': submitted && f.datasetLocation.errors }" bindLabel="name"
                          bindValue="id"
                          formControlName="datasetLocation"
                          id="datasetLocation">
                        </ng-select>
                        <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.datasetLocation.errors }"
                          class="form-control" id="selectedDatasetLocation"
                          name="datasetLocation" type="text">

                          @if (submitted && f.datasetLocation.errors) {
                            <div class="invalid-feedback">
                              @if (f.datasetLocation.errors.required) {
                                <span translate>Google dataset location
                                required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    <!-- MACHINE TAG-->
                    @if (!userRole.isUserRole && !userRole.isAnalyticsRole && !userRole.isViewerRole) {
                      <scitis-machine-tag
                        (isTemplateChange)="onIsMachineTemplateChange($event)"
                        (machineTagChange)="onMachineTagChanged($event)"
                        [category]="machine.category"
                        [isAddOperation]="isNewMachine"
                        [isTechAdminOrHigher]="userRole.isTechAdminRole || userRole.isSuperAdminRole"
                        [isAdminOrHigher]="isAdminOrHigher()"
                        [isTemplate]="machine.templateMachine"
                        [machineTag]="machine.machineTag">
                      </scitis-machine-tag>
                    }

                    @if (userRole.isTechAdminRole || userRole.isSuperAdminRole) {
                      <div class="form-row">
                        <!-- MACHINE GATEWAY-->
                        <div class="col-12">
                          <scitis-machine-default-gateway
                            (defaultGatewayDetailsChange)="onDefaultGatewayDetailsChanged($event)"
                            (gatewayConfigurationIssues)="onDefaultGatewayDetailsIssues($event)"
                            [isAddOperation]="isNewMachine"
                            [machineTag]="machine.machineTag"
                            [machineTemplate]="machine.templateMachine"
                            [organizationId]="selectedOrganizationId"
                            [isAdminOrHigher]="isAdminOrHigher()"
                            >
                          </scitis-machine-default-gateway>
                        </div>
                      </div>
                    }

                    <scitis-machine-location (formIsValid)="onFormIsValid($event)"
                      (updatedLocationDetailsEvent)="onUpdatedLocationDetailsEvent($event)"
                      [locationDetails]="locationDetails"
                      [machineName]="f.type.value"
                      [isAdminOrHigher]="isAdminOrHigher()"
                      [submitted]="submitted">
                    </scitis-machine-location>


                  </div>

                  <div class="modal-footer">
                    <div class="modal-footer-inner">
                      <div class="row align-items-center flex-fill">
                        <div class="col">
                          <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
                        </div>
                        <div class="col-auto">
                          <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
                            <span translate>Cancel</span>
                          </button>
                          <button [disabled]="isDisabledSaveBtn || !isAdminOrHigher()" class="btn btn-primary"
                            type="submit">
                            <span translate>Save</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
